import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Attachment14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7.46967 1.46967C8.86713 0.0722042 11.1329 0.0722041 12.5303 1.46967C13.9278 2.86713 13.9278 5.13286 12.5303 6.53033L11.4697 5.46967C12.2813 4.65799 12.2813 3.342 11.4697 2.53033C10.658 1.71865 9.34201 1.71865 8.53033 2.53033L3.53039 7.53033C2.71871 8.34201 2.71871 9.658 3.53039 10.4697C4.34206 11.2813 5.65805 11.2813 6.46973 10.4697L9.46967 7.46967C9.72906 7.21028 9.72906 6.78972 9.46967 6.53033C9.21028 6.27094 8.78972 6.27094 8.53033 6.53033L5.53033 9.53033L4.46967 8.46967L7.46967 5.46967C8.31485 4.62449 9.68515 4.62449 10.5303 5.46967C11.3755 6.31485 11.3755 7.68515 10.5303 8.53033L7.53039 11.5303C6.13293 12.9278 3.86719 12.9278 2.46973 11.5303C1.07227 10.1329 1.07227 7.86713 2.46973 6.46967L7.46967 1.46967Z'
      fill='currentColor'
    />
  </Svg>
);

Attachment14.displayName = 'Attachment14';
export default Attachment14;
